import { HojasdeVida } from "./hojasdevida.view";
import "./style.scss";

export const SeguimientoHojasdeVida = () => {
  return <HojasdeVida />;
};
